"use strict";
exports.__esModule = true;
exports.LocalStorage = void 0;
var get = function (key) { return window.localStorage.getItem(key); };
var set = function (key, value) { return window.localStorage.setItem(key, JSON.stringify(value)); };
exports.LocalStorage = { get: get, set: set };
//# sourceMappingURL=local-storage.js.map